import React from "react";
import Successfull from "./Successfull";
import Unsuccessfull from "./Unsuccessfull";

const logoSrc = require('../../assets/default_logo.svg')

const IndexPage = ({ payment }) => {
	const { status } = payment

	return(
		<div className={`payment-result ${status === 'success' ? 'success' : 'fail'}`}>
			<div className="content-area">
				<img src={logoSrc} className="logo" />
				<div className="card">
					{status === 'success' ? <Successfull {...payment} /> : <Unsuccessfull {...payment} /> }
					<div className="details-bottom">
						<div className="heading">Have questions?</div>
						<div className="description">You can check out our FAQ or our support page for more information</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default IndexPage;
